import React, { useEffect, useState } from "react";

export default function MailboxForm({
  mailbox,
  tenants = [],
  onSubmit,
  onCancel,
}) {
  const [formData, setFormData] = useState({
    number: "",
    tenantId: "",
    hasMail: false,
  });

  // Prefill when editing
  useEffect(() => {
    if (mailbox) {
      setFormData({
        number: mailbox.number || "",
        tenantId: mailbox.tenant?.id || "",
        hasMail: mailbox.hasMail || false,
      });
    } else {
      setFormData({
        number: "",
        tenantId: "",
        hasMail: false,
      });
    }
  }, [mailbox]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof onSubmit !== "function") {
      console.error("MailboxForm: onSubmit is missing or invalid");
      return;
    }

    onSubmit({
      number: formData.number.trim(),
      tenantId: formData.tenantId ? Number(formData.tenantId) : null,
      hasMail: formData.hasMail,
    });
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <label>
        Mailbox Number
        <input
          name="number"
          placeholder="Mailbox number"
          value={formData.number}
          onChange={handleChange}
        />
      </label>

      <label>
        Tenant
        <select
          name="tenantId"
          value={formData.tenantId}
          onChange={handleChange}
        >
          <option value="">No Tenant</option>

          {tenants.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name} ({t.email})
            </option>
          ))}
        </select>
      </label>

      <label className="admin-checkbox">
        <input
          type="checkbox"
          name="hasMail"
          checked={formData.hasMail}
          onChange={handleChange}
        />
        <span>Has Mail</span>
      </label>

      <div className="admin-form-actions">
        <button className="admin-button admin-button-primary" type="submit">
          {mailbox ? "Update" : "Add"}
        </button>

        <button
          className="admin-button admin-button-secondary"
          type="button"
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </form>
  );
}
